const APP_ROOT_ID = 'root';

const EDITABLE_TAGS = new Set(['INPUT', 'TEXTAREA', 'SELECT']);

function getAppRoot(): HTMLElement | null {
  return document.getElementById(APP_ROOT_ID);
}

function isEditableElement(element: Element): boolean {
  if (!(element instanceof HTMLElement)) {
    return false;
  }

  if (EDITABLE_TAGS.has(element.tagName)) {
    return true;
  }

  return element.isContentEditable;
}

function isFocusOutsideAppRoot(): boolean {
  const { activeElement } = document;
  const appRoot = getAppRoot();

  if (!activeElement || !appRoot) {
    return false;
  }

  if (
    activeElement === document.body ||
    activeElement === document.documentElement
  ) {
    return false;
  }

  return !appRoot.contains(activeElement);
}

/**
 * Returns true when a global keyboard shortcut should not fire.
 *
 * Used with react-hotkeys-hook's `ignoreEventWhen` to prevent single-key
 * shortcuts from triggering while the user is typing or focused outside
 * the React app (e.g. third-party chat widgets injected on the page).
 */
export function shouldIgnoreKeyboardShortcut(event: KeyboardEvent): boolean {
  if (document.activeElement?.tagName === 'IFRAME') {
    return true;
  }

  if (isFocusOutsideAppRoot()) {
    return true;
  }

  return event.composedPath().some((node) => {
    if (!(node instanceof Element)) {
      return false;
    }

    return isEditableElement(node);
  });
}
